<p-spinner size="30" (keyup)="onKeyUp($event)" (onChange)="onSpinnerChange($event)" [(ngModel)]="this.field.fieldValue"></p-spinner>
